// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aLXSIBpZE6ZAjV7_9ris{flex-direction:column;gap:16px;display:flex}.hxUtqJQ1kfQjvazc84R8{flex-direction:column;gap:4px;display:flex}.OxJuo2TcYEwVdBmEBkT7{padding:12px}.A_yrn6ADGMhxah13DHz8{color:var(--content-primary-tertiary);align-items:flex-start}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `aLXSIBpZE6ZAjV7_9ris`,
	"field": `hxUtqJQ1kfQjvazc84R8`,
	"textField": `OxJuo2TcYEwVdBmEBkT7`,
	"checkbox": `A_yrn6ADGMhxah13DHz8`
};
export default ___CSS_LOADER_EXPORT___;
